function formatPaginationParams(pagination) {
  let params = Object.assign({}, pagination);

  let sortBy = params.sortBy;
  if (sortBy) {
    params.sortBy = sortBy[0];
  }
  let sortDesc = params.sortDesc;
  if (sortDesc) {
    params.sortDesc = sortDesc[0];
  }
  delete params.mustSort;
  delete params.multiSort;
  if (!pagination.search) {
    delete params.search;
  }
  return params;
}

const TOTAL_COUNT_KEY = "x-total-count";

export { formatPaginationParams, TOTAL_COUNT_KEY };
